import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_customer_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Update KYC", -1)
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_customer_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_customer_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_customer_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "fv-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-4" }, "Select a status to update", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_13 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Currently ")
const _hoisted_15 = { class: "d-flex gap-3" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("In Progress")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("In Review")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Approved")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Declined")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-6" }, null, -1)
const _hoisted_21 = { class: "fv-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-4" }, "Update KYC Step", -1)
const _hoisted_23 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: _ctx.$modals.KYC_STATUS_MODAL,
    ref: "updateKYCStatusRef",
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            id: `${_ctx.$modals.KYC_STATUS_MODAL}_close`,
            "data-bs-dismiss": "modal",
            class: "btn btn-icon btn-sm btn-active-icon-primary"
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ], 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              (_ctx.status)
                ? (_openBlock(), _createElementBlock("small", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("i", null, _toDisplayString(_ctx.$filters.getStatusLabel(_ctx.status)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_Badge, {
                  variant: "warning",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateStatus(_ctx.ProgressStatus.IN_PROGRESS)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _createVNode(_component_Badge, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateStatus(_ctx.ProgressStatus.IN_REVIEW)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }),
                _createVNode(_component_Badge, {
                  variant: "success",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateStatus(_ctx.ProgressStatus.COMPLETED)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }),
                _createVNode(_component_Badge, {
                  variant: "danger",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateStatus(_ctx.ProgressStatus.CANCEL)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", null, [
                _createVNode(_component_el_select, {
                  placeholder: "Select One",
                  modelValue: _ctx.currentStep,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentStep) = $event)),
                  class: "border-active"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepOptions, (i) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: i.text,
                        key: i.value,
                        value: i.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_Button, {
                    label: "Save",
                    disabled: _ctx.loading,
                    onClick: _ctx.handleUpdateStep
                  }, null, 8, ["disabled", "onClick"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}